import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
	NOTIFICATION_COUNT_VIEW,
	NOTIFICATION_DURATION,
	NotificationMessageModel,
	NotificationPopupModel,
} from 'Modules'

type State = {
	notifications: NotificationPopupModel[]
}

const initialState: State = {
	notifications: [],
}

export namespace NotificationPopupNS {
	export type Add = PayloadAction<NotificationPopupModel>
	export type Remove = PayloadAction<number>
	export type UpdateTimer = PayloadAction
	export type ShowMessage = PayloadAction<NotificationMessageModel>
}

export const notificationPopupSlice = createSlice({
	name: 'notificationPopup',
	initialState,
	reducers: {
		add: (state, action: NotificationPopupNS.Add) => {
			const countView = state.notifications.filter((notify) => notify.view).length
			state.notifications.push({
				...action.payload,
				created: new Date(),
				view: Boolean(countView < NOTIFICATION_COUNT_VIEW),
			})
		},
		remove: (state, action: NotificationPopupNS.Remove) => {
			state.notifications.splice(action.payload, 1)
		},
		updateTimer: (state, action: NotificationPopupNS.UpdateTimer) => {
			const currentDate = new Date()
			state.notifications = state.notifications.filter(
				(current) =>
					(current.view &&
						Number(currentDate) - Number(current.created) < NOTIFICATION_DURATION.NORMAL) ||
					!current.view
			)
			const countView = state.notifications.filter((notify) => notify.view).length
			if (countView < NOTIFICATION_COUNT_VIEW) {
				const findIndex = state.notifications.findIndex((notify) => !notify.view)
				if (findIndex !== -1) state.notifications[findIndex].view = true
			}
		},
		showMessage: (state, action: NotificationPopupNS.ShowMessage) => {},
	},
})

export const showNotificationAction = notificationPopupSlice.actions.showMessage
